export const isValueInEnum = (value: string, enumType: any): boolean => {
  return Object.values(enumType).includes(value);
};
